import React from 'react';
import { Gradient } from '../Gradient';

const Bulb = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M10.4671 13.3933V14.8891C10.4671 15.7336 9.78246 16.4183 8.9379 16.4183C8.10141 16.4183 7.42015 15.7462 7.40884 14.9097L7.38833 13.3933M10.4671 13.3933H7.38833M10.4671 13.3933C10.4671 12.8723 10.7983 12.4197 11.2353 12.1361C12.3505 11.4123 13.0846 10.181 13.0846 8.78373C13.0846 6.55618 11.2189 4.75039 8.91749 4.75039C6.61606 4.75039 4.75039 6.55618 4.75039 8.78373C4.75039 10.1809 5.48436 11.4121 6.59945 12.1359C7.03849 12.4209 7.37594 12.87 7.38833 13.3933M8.91749 2.66684V1M15.1681 8.91749H16.835M13.3372 13.3374L14.5158 14.516M1 8.91749H2.66684M3.31904 3.31897L4.49768 4.4976M4.4974 13.3372L3.31876 14.5158M14.5159 3.31904L13.3373 4.49768" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>

  );
};

export default Bulb;